<template>
  <div v-bind:class="hClass" v-html="text"></div>
</template>

<script>
export default {
  name: 'CtfRichTextHeading',
  props: {
    text: {
      type: String,
      required: true
    },
    hClass: {
      type: String,
      required: true
    }
  }
}
</script>
